import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=4406dce1&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"
import style0 from "./Cards.vue?vue&type=style&index=0&id=4406dce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406dce1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1FeaturedGame: require('/app/components/Theme1/FeaturedGame.vue').default})
